import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogTitle,
} from 'components/common/Dialog';
import IconPen from 'components/icons/IconPen';
import IconButton from 'components/common/IconButton';

import { submit, isSubmitting, isDirty, formValueSelector } from 'redux-form';

import InventoryCreateEditForm from './InventoryCreateEditForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '15px 2px 30px',
  },
  dialogPaper: {
    maxWidth: 950,
    minWidth: 950,
  },
  buttonEdit: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    color: theme.palette.primary[500],
  },
  iconPen: {
    width: 15,
    height: 15,
  },
});

class InventoryCreateEditDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editStockLineProduct: false,
      HCPCSCodes: props.Product ? props.Product['HCPC Codes'].reduce((accumulator, currentValue) => [
        ...accumulator,
        ...currentValue,
      ],[]) : [],
    };

    this.onEditStockLineProductButtonClick = this.onEditStockLineProductButtonClick.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
    this.onHCPCSCodeAdd = this.onHCPCSCodeAdd.bind(this);
  }

  onEditStockLineProductButtonClick() {
    this.setState({ editStockLineProduct: true });
  }

  onDialogExited() {
    this.setState({ editStockLineProduct: false });
  }

  onHCPCSCodeAdd(HCPCSCode) {
    this.setState({
      HCPCSCodes: [
        ...this.state.HCPCSCodes,
        HCPCSCode,
      ],
    })
  }

  render() {
    const {
      form,
      initialValues,
      variant,
      open,
      onEnter,
      onEntered,
      onClose,
      onVendorCreate,
      onCategoryCreate,
      onConditionCreate,
      onWarehouseCreate,
      onSubmitSuccess,
      submitting,
      dirty,
      actions,
      supplyType,
      categoryType,
      Product,
      business,
      classes,
    } = this.props;
    const { editStockLineProduct, HCPCSCodes } = this.state;
    return (
      <Dialog
        paperClassName={classes.dialogPaper}
        open={open}
        onClose={onClose}
        onEnter={onEnter}
        onEntered={onEntered}
        onExited={this.onDialogExited}
        maxWidth={false}
      >
        <DialogTitle
          {...(['stock-line-create', 'stock-line-edit'].indexOf(variant) !== -1 && !editStockLineProduct) ? { secondaryContent: (
            <IconButton
              className={classes.buttonEdit}
              onClick={this.onEditStockLineProductButtonClick}
              tooltipContent="Edit Product"
            >
              <IconPen className={classes.iconPen} />
            </IconButton>
          )} : {}}
        >
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {variant === 'create' && 'Add Product'}
            {variant === 'edit' && 'Edit Product'}
            {variant === 'copy' && 'Clone Product'}
            {variant === 'copy-add' && 'Clone Product and Add Inventory'}
            {variant === 'stock-line-create' && 'Add Inventory'}
            {variant === 'stock-line-edit' && 'Edit Inventory'}
          </Typography>
        </DialogTitle>
        <InventoryCreateEditForm
          className={classes.form}
          onSubmitSuccess={(values) => {
            onSubmitSuccess(values);
            onClose();
          }}
          onVendorCreate={onVendorCreate}
          onCategoryCreate={onCategoryCreate}
          onConditionCreate={onConditionCreate}
          onWarehouseCreate={onWarehouseCreate}
          form={form}
          variant={variant}
          {...initialValues ? { initialValues } : { initialValues: {
            'Vendor ID': null,
            'Vendor Contact Person': null,
            'Vendor Email': null,
            'Vendor Mobile Phone': null,
            'HCPC Codes': [],
            'Do not override': false,
            'Supply Type': 'Units',
            'Is Active': true,
            ...business && business.Facilities && business.Facilities[0] ? {
              'Facility ID': business.Facilities[0].ID,
              'Facility Name': business.Facilities[0]['Company Info']['Company Name'],
              'Selected Facility Name': business.Facilities[0]['Company Info']['Company Name'],
              'Facility State': business.Facilities[0]['Company Address'].State,
              'Facility Is Rural': business.Facilities[0]['Company Address']['Is Rural'],
            } : {},
          }}}
          supplyType={supplyType}
          categoryType={categoryType}
          onClose={onClose}
          dirty={dirty}
          submitting={submitting}
          editStockLineProduct={editStockLineProduct}
          Product={Product}
          onHCPCSCodeAdd={this.onHCPCSCodeAdd}
          HCPCSCodes={HCPCSCodes}
          business={business}
        />
      </Dialog>
    );
  }
}

InventoryCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onEnter: PropTypes.func,
  onEntered: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  onVendorCreate: PropTypes.func,
  onCategoryCreate: PropTypes.func,
  onConditionCreate: PropTypes.func,
  onWarehouseCreate: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.string,
  variant: PropTypes.oneOf(['create', 'edit', 'copy', 'copy-add', 'stock-line-create', 'stock-line-edit']),
  initialValues: PropTypes.shape({
    'HCPC Codes': PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.string),
    ),
  }),
  supplyType: PropTypes.oneOf(['Units', 'Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryCreateEditDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onEnter: () => {},
  onEntered: () => {},
  onSubmitSuccess: () => {},
  onVendorCreate: () => {},
  onCategoryCreate: () => {},
  onConditionCreate: () => {},
  onWarehouseCreate: () => {},
  form: 'inventoryCreate',
  initialValues: null,
  variant: 'create',
  supplyType: 'Units',
};

const mapStateToProps = (store, ownProps) => {
  const selector = formValueSelector(ownProps.form);

  return {
    submitting: isSubmitting(ownProps.form)(store),
    dirty: isDirty(ownProps.form)(store),
    supplyType: selector(store, 'Supply Type'),
    categoryType: selector(store, 'Category Name'),
    business: store.business.data,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InventoryCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryCreateEditDialog/InventoryCreateEditDialog.js